import React, { FunctionComponent } from 'react'
import { Path, Svg } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

export const UploadIcon: FunctionComponent<UploadIconProps> = ({ size = 19, fillColor, ...props }) => {
  const { colors } = useTheme()

  return (
    <Svg width={size} height={size} viewBox='0 0 19 18' {...props}>
      <Path
        fill={fillColor || colors.iconDefault}
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.75 6.00049C13.94 6.00049 14.13 5.92949 14.28 5.78049C14.57 5.49049 14.57 5.00949 14.28 4.71949L10.03 0.469488C9.96 0.400488 9.88 0.349488 9.79 0.309488C9.7 0.269488 9.6 0.250488 9.5 0.250488C9.4 0.250488 9.3 0.269488 9.21 0.309488C9.12 0.349488 9.04 0.400488 8.969 0.469488L4.719 4.71949C4.43 5.00949 4.43 5.49049 4.719 5.78049C5.009 6.07049 5.49 6.07049 5.78 5.78049L8.75 2.80949V12.2505C8.75 12.6605 9.09 13.0005 9.5 13.0005C9.91 13.0005 10.25 12.6605 10.25 12.2505V2.80949L13.219 5.78049C13.37 5.92949 13.56 6.00049 13.75 6.00049ZM17 10.7505C17 10.3405 17.34 10.0005 17.75 10.0005C18.16 10.0005 18.5 10.3405 18.5 10.7505V15.0005C18.5 16.6505 17.15 18.0005 15.5 18.0005H3.5C1.85 18.0005 0.5 16.6505 0.5 15.0005V10.7505C0.5 10.3405 0.84 10.0005 1.25 10.0005C1.66 10.0005 2 10.3405 2 10.7505V15.0005C2 15.8305 2.67 16.5005 3.5 16.5005H15.5C16.33 16.5005 17 15.8305 17 15.0005V10.7505Z'
      />
    </Svg>
  )
}

type UploadIconProps = {
  size?: string | number
  fillColor?: string
}
